export const StockActionTypes = {
  ASSET: 'stock_action_asset',
  INSURANCE: 'stock_action_insurance'
};
